import CONFIG from '../config'

// Apollo + GRAPHQL
import { ApolloClient, createNetworkInterface } from 'apollo-client'
// import { SubscriptionClient, addGraphQLSubscriptions } from 'subscriptions-transport-ws'

const networkInterface = createNetworkInterface({
  uri: CONFIG.api.graphql,
  transportBatching: true
})

// const wsClient = new SubscriptionClient(CONFIG.api.websocket, {
//   reconnect: true,
//   connectionParams: {
//   }
// })

networkInterface.use([{
  applyMiddleware (req, next) {
    const token = localStorage.getItem('_auth.token') ? localStorage.getItem('_auth.token') : null

    if (!req.options.headers) {
      req.options.headers = {}
    }
    if (token) {
      req.options.headers.authorization = `Bearer ${token}`
    }
    next()
  }
}])
.useAfter([{
  applyAfterware ({ response }, next) {
    if (response.status === 500) {
      console.error('Server returned an error', response)
    }
    next()
  }
}])

// const networkInterfaceWithSubscriptions = addGraphQLSubscriptions(
//   networkInterface,
//   wsClient,
// )

const apolloClient = new ApolloClient({
  networkInterface: networkInterface,
  connectToDevTools: true,
  dataIdFromObject: (result) => {
    if (result.id && result.__typename) {
      return result.__typename + result.id
    }
    return null
  }
})

export const apollo = apolloClient



// WEBPACK FOOTER //
// ./src/apollo/index.js